<template>
  <div
    class="ai-search"
    ref="ai-search"
  >
    <div class="ai-search__header">
      <img
        class="ai-search__logo"
        src="@/assets/colorIcon/ai-star.svg"
        alt="ai"
      >
      <p class="ai-search__title">
        Deep Search
      </p>
    </div>
    <SearchLoading v-if="loading" />
    <NotAvailable v-else-if="list.length === 0" />
    <template v-else>
      <H5SearchList
        v-if="deviceType === 'MOBILE'"
        :list="list"
      />
      <SearchList
        v-else-if="deviceType === 'PC'"
        :list="list"
      />
      <SearchFeedback class="ai-search__feedback" />
    </template>
    <SearchBanner
      :status="status"
      v-if="isShowSearchBanner"
      :style="{ top: searchBannerTop, transition: 'top 0.3s ease-in-out' }"
    >
      <H5SearchList
        v-if="deviceType === 'MOBILE'"
        :list="list"
      />
      <SearchList
        v-else-if="deviceType === 'PC'"
        :list="list"
      />
      <SearchFeedback class="ai-search__feedback" />
    </SearchBanner>
  </div>
</template>

<script setup>
import { SearchLoading } from './SearchLoading'
import NotAvailable from './NotAvailable.vue'
import H5SearchList from './H5SearchList.vue'
import SearchList from './SearchList.vue'
import SearchBanner from './SearchBanner.vue'
import { useIntersectionObserver, useMutationObserver } from '@vueuse/core'
import SearchFeedback from './SearchFeedback.vue'
import { useDeepSearch } from './hooks/useDeepSearch'
import { useDevice } from '@/hooks/useDevice'

const aiSearchRef = useTemplateRef('ai-search')
const isVisible = shallowRef(true)

const isShowSearchBanner = computed(() => {
  return isVisible.value === false && (loading.value || list.value.length > 0)
})

const { deviceType } = useDevice()

const { loading, list, status } = useDeepSearch()

useIntersectionObserver(
  aiSearchRef,
  ([entry]) => {
    isVisible.value = entry?.isIntersecting || false
  }
)

const searchBannerTop = ref(null)

onMounted(() => {
  useMutationObserver(document.querySelector('.search-ceiling'), (mutations) => {
    const mutation = mutations[0]
    if (!mutation || mutation.type !== 'attributes' || mutation.attributeName !== 'class') return

    const { offsetHeight, className } = mutation.target
    if (className.includes('ceiling-up')) {
      searchBannerTop.value = `${offsetHeight}px`
    } else if (className.includes('ceiling-down')) {
      searchBannerTop.value = '0px'
    }
  }, {
    attributes: true,
    attributeFilter: ['class']
  })
})
</script>

<style lang="less" scoped>
.ai-search {
  padding: 16px 0;

  @media (min-width: 1024px) {
    padding: 32px 0;
  }

  &__header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  &__logo {
    width: 24px;
    height: 24px;

    @media (min-width: 1024px) {
      width: 28px;
      height: 28px;
    }
  }

  &__title {
    padding-top: 3px;
    font-family: mon-700;
    font-size: 16px;

    @media (min-width: 1024px) {
      font-size: 20px;
    }
  }

  &__feedback {
    margin-top: 12px;
  }
}
</style>
